import React, { useState, useContext, useEffect } from "react";
import { Modal, Tabs, Tab, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";
import ForgotPasswordForm from "./ForgotPasswordForm";
import { ActiveTour, DisclaimerSigned, UserInfo } from "../helper/Context";
import IntroTour from "../tours/IntroductoryTour";
import { APIGetUserInfo } from "../helper/APIFunctions";

const LoginModal = (props) => {
  const [showForgetPass, setShowForgetPass] = useState(false);
  const [activeTab, setActiveTab] = useState(props.defaultTab || "login");
  const [isOAuthLoading, setIsOAuthLoading] = useState(false);
  const { setActiveTour } = useContext(ActiveTour);
  const navigate = useNavigate(); // Move this to the top before useEffect
  
  // Reset loading state when modal opens
  useEffect(() => {
    if (props.isOpen) {
      setIsOAuthLoading(false);
    }
  }, [props.isOpen]);
  
  useEffect(() => {
    if (props.isOpen) {
      window?.google?.accounts?.id?.renderButton(
        document.getElementById("google-login-button"),
        {
          theme: "filled_black", size: "large", text: "continue_with", shape: "pill", click_listener: () => {
            if (!window._snorkle){
              window._snorkle = {};
            }
            window._snorkle.oauthRequestType = "login-modal";
          }
        }
      );
    }
  }, [props.isOpen]);
  useEffect(() => {
    const element = document.getElementById("login-modal");
    if (element){
      const handleSuccess = (event) => {
        setIsOAuthLoading(false); // Clear loading state
        setShowForgetPass(false);
        props.onClose();
        // Use redirectPath if provided, otherwise default to /welcome
        navigate(props.redirectPath || "/welcome");
      };
      
      const handleError = (event) => {
        setIsOAuthLoading(false); // Clear loading state on error
      };

      const handleStarted = (event) => {
        setIsOAuthLoading(true); // Set loading state when Google button is clicked
      };
      
      element.addEventListener("oauth-login-success", handleSuccess);
      element.addEventListener("oauth-login-error", handleError);
      element.addEventListener("oauth-login-started", handleStarted);
      return () => {
        element.removeEventListener("oauth-login-success", handleSuccess);
        element.removeEventListener("oauth-login-error", handleError);
        element.removeEventListener("oauth-login-started", handleStarted);
      };
    }
  }, [props.onClose, props.isOpen, props.redirectPath, navigate]);
  const ohcb = () => {
    setShowForgetPass(false);
    setIsOAuthLoading(false); // Reset loading state when modal closes
    props.onClose();
  };
  return (
    <>
      <Modal show={props.isOpen} onHide={ohcb} onExited={props.onClosed} className="login-modal" id="login-modal">
        <Modal.Header closeButton closeVariant="white">
          <h3>{showForgetPass ? "Reset Password" : "Login / Register"}</h3>
        </Modal.Header>
        <Modal.Body style={{ position: 'relative' }}>
          {isOAuthLoading && (
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000,
              borderRadius: '0.3rem'
            }}>
              <Spinner animation="border" variant="light" style={{ width: '3rem', height: '3rem' }} />
              <p className="text-white mt-3" style={{ fontSize: '1.1rem' }}>
                Signing in with Google...
              </p>
            </div>
          )}
          <div className={showForgetPass ? "d-none" : "mb-4"}>
            <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} id="login-register-tabs">
              <Tab eventKey="login" title="Login" />
              <Tab eventKey="register" title="Register" />
            </Tabs>
            <div className="login-modal-tab-content">
              {activeTab === 'login' && (
                <LoginForm
                  onSuccessCB={() => {
                    ohcb();
                    // Use redirectPath if provided, otherwise default to /welcome
                    navigate(props.redirectPath || "/welcome");
                  }}
                  showForgetPass={() => setShowForgetPass(true)}
                  onLoginStateChange={props.onLoginStateChange}
                />
              )}
              {activeTab === 'register' && (
                <RegisterForm
                  onSuccessCB={() => {
                    ohcb();
                    // Use redirectPath if provided, otherwise default to /home
                    navigate(props.redirectPath || "/home");
                  }}
                />
              )}
            </div>
          </div>
          <div className={showForgetPass ? "mb-4" : "d-none"}>
            <ForgotPasswordForm
              closeForgetPass={() => setShowForgetPass(false)}
            />
          </div>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            margin: '20px 0',
            textAlign: 'center'
          }}>
            <div style={{
              flex: 1,
              height: '2px',
              backgroundColor: '#adb5bd'
            }}></div>
            <span style={{
              padding: '0 15px',
              color: '#6c757d',
              fontSize: '0.9rem',
              fontWeight: '500'
            }}>or</span>
            <div style={{
              flex: 1,
              height: '2px',
              backgroundColor: '#adb5bd'
            }}></div>
          </div>
          <div id="google-login-button">
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default LoginModal;
